import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AbstractControl, FormControl, ReactiveFormsModule, ValidatorFn } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';

@Component({
  selector: 'form-builder-color-picker',
  template: `
    <glxy-form-field>
      <glxy-label>{{ name }}</glxy-label>

      <!-- color-swatch -->
      <input type="color" [formControl]="field" [value]="field.value" matInput />

      <!-- color-text-code -->
      <input
        type="text"
        [attr.data-cy]="'colorpicker-' + name.replace(' ', '-').toLowerCase()"
        [formControl]="field"
        [value]="field.value"
        matInput
      />
      <glxy-error *ngIf="field.invalid">{{ field.errors['colorCode'] }}</glxy-error>
    </glxy-form-field>
  `,
  styles: [],
  imports: [CommonModule, GalaxyFormFieldModule, MatInputModule, ReactiveFormsModule],
})
export class ColorPickerComponent {
  @Input() field: FormControl<string> = new FormControl('', { nonNullable: true });
  @Input() name = '';
}

export function newColorControl(initial: string): FormControl<string> {
  const colorCodeValidator: ValidatorFn = (control: AbstractControl) => {
    if (!control.value) {
      return {
        colorCode: 'Colors should be like #a1a1a1',
      };
    }

    const validColor = /^#[\da-fA-F]{6}$/.test(control.value?.toString());
    if (!validColor) {
      return {
        colorCode: 'Colors should be like #a1a1a1',
      };
    }
    return null;
  };

  return new FormControl<string>(initial, {
    nonNullable: true,
    validators: [colorCodeValidator],
  });
}
